module.exports = __webpack_public_path__ + "static/hip-groin-5c3b963c3a49a305edc0cb8f46cb02f7.jpg";